const cloneSelect = () => {
	let selects =  $('.group-custom-rates select');

	selects.each(function(index, el) {
		const $select = $(el);

    $select.clone().appendTo('.custom-rate-select');
	});

}

export default cloneSelect;